/**
 * The Codes used in this application's api errorCode / successCode that would flag a specific case.
 */
export default class ApiResponseCodes {
    /**
     * Specifies that the entered Serial number is invalid for a part support request
     */
    static invalidSerialNumber: number = -510;

    /**Specifies that the entered RGA for a part support request is duplicated*/
    static duplicateRGA: number = -520;

    /**
     * Specifies that the entered RGA for a part support request is invalid.
     * this code is only seen when the validateRGA api is called.
     */
    static invalidRGA: number = 520;

    /**
     * Specifies that the specific part support that we are applying for is expired and must be renewed before
     *  continuation.
     */
    static expiredPartSupport: number = -530;

    /**
     * Specifies that some pre-authorized payments failed and were refunded when generating an invoice from a
     * sales order.
     */
    static preAuthorizedPaymentsFailed: number = 605;

    /**
     * When processing the orders, the apis may return this code when the 3rd party libraries we use for inventory
     * management fail or any reason.
     * // related to spire
     */
    static backendOrderingGeneralFailure: number = 601;

    /**
     * When new users can not be registered into the system.
     */
    static registrationDisabled: number = 602;

    /**
     * When creating a user fails because email and/or phone already exist in the system.
     */
    static userAlreadyExists: number = 500;

    /**
     * When the operator creates a quote but need to create a sales person profile first
     */
    static requireSalesPersonProfile: number = 603;

    /**
     * When all the products of an attempt in a bulk-price-change are attempted (with status success or failed).
     */
    static bulkPriceChangeAttemptIsFinished: number = -173;

    /**
     * When the selected customer credit is already assigned to other part support requests, and we are trying to assign it to another
     * request as well.
     */
    static duplicateCustomerCredit: number = 606;

    /**
     * When the selected vendor credit is already assigned to other part support requests, and we are trying to assign it to another
     * request as well.
     */
    static duplicateVendorCredit: number = 606;

    /**
     * When the selected customer's free freight information is not detached from the system.
     */
    static freeFreightCustomerNotDetached: number = -4045;

    /**
     * When the product does not have any variants.
     */
    static productHasNoVariants: number = 105;

    /**
     * Vendor part record is conflicting with another record.
     */
    static vendorPartConflictingRecord = -130;

    /**
     * When a category with the title "Default" is required for the operation.
     */
    static defaultCategoryRequiresForIndustry = -184;

    /**
     * When the category specified in a product-category assignment import is not found.
     */
    static importParentCategoryNotFound: number = -211;
    /**
     * When the category specified in a product-category assignment import is not found.
     */
    static importLeafCategoryNotFound: number = -212;
    /**
     * When the category specified in a product-category assignment import is not found.
     */
    static importCategoryMismatch: number = -825;

    /**
     * When CreatePartInWarehouse fails because the part already exists in that warehouse (Spire constraint).
     */
    static spirePartAlreadyInWarehouse: number = -601;

    /**
     * When the product (part number) specified in a product-category assignment import is not found.
     */
    static importProductNotFound: number = -161;
}
